import { Component, OnInit } from '@angular/core';
import { CategoryService } from 'src/app/services/category.service';
import { Category } from 'src/app/models/category';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {
  public loadingCategories: boolean = true;
  public categories: Category[];
  public filters = [];
  public breadcrumbLinks=[];
  public thisPage:string='Categories';

  constructor(private categoryService: CategoryService) {}

  ngOnInit() {
    this.categoryService.getCategories().subscribe(categories=>{
      this.categories = categories;
      this.loadingCategories = false;
    })
  }

}
